export default function ErrorState({ message, onRetry }) {
  if (!message) return null;
  return (
    <div className="analytics-alert is-critical" role="alert">
      <span>{message}</span>
      {onRetry ? (
        <button type="button" className="analytics-btn" onClick={onRetry}>
          Reintentar
        </button>
      ) : null}
    </div>
  );
}
